export default class AddressError extends Error {
  constructor() {
    super('Houve um problema com o tratamento de endereços.');
    this.name = 'AddressError';
  }
}
